export default function Marquee({ items }) {
  const list = items || [
    "312 itineraries live", "47 verified creators", "47 countries",
    "₹99 — ₹4,999", "No subscription", "Yours forever",
    "Pay once", "Day 1 always free",
  ];
  const renderRow = (key) => (
    <span key={key}>
      {list.map((t, i) => (
        <span key={i} style={{ display: "inline-flex", alignItems: "center" }}>
          {t}
          <span className="marq-dot" />
        </span>
      ))}
    </span>
  );
  return (
    <div className="marq" data-testid="marquee">
      <div className="marq-track">
        {renderRow("a")}
        {renderRow("b")}
      </div>
    </div>
  );
}
